import angular from 'angular';
import LandingComponent from './landing.componet';
import LandingService from './landing.service';
import landingConfig from './landing.config';


let landingModule = angular.module('landing', [])
    .component('landing', LandingComponent)
    .service('LandingService', LandingService)
    .config(landingConfig);

export default landingModule;



/** WEBPACK FOOTER **
 ** ./www/components/landing/landing.js
 **/